import React from "react";
import * as styles from "./WordButton.module.css";
import { Toggle } from "../ui/toggle";
import { Check } from "lucide-react";

import { GameStatusContext } from "../../providers/GameStatusProvider";

function WordButton({ word, fullCandidateSize, wordIndex = 0 }) {
  const { guessCandidate, setGuessCandidate } =
    React.useContext(GameStatusContext);
  const [isSelected, setIsSelected] = React.useState(
    !!guessCandidate.includes(word)
  );

  const isCandidateListFull = guessCandidate.length == fullCandidateSize;

  React.useEffect(() => {
    setIsSelected(!!guessCandidate.includes(word));
  }, [guessCandidate]);

  function flipSelection() {
    if (isSelected) {
      // remove from candidateGuess
      const updatedGuessCandidate = guessCandidate.filter((w) => {
        return w !== word;
      });
      setGuessCandidate(updatedGuessCandidate);
      // set state to *not* selected
      setIsSelected(false);
    } else {
      // check if the candidate array is full
      if (!isCandidateListFull) {
        // add to candidateGuess array
        setGuessCandidate([...guessCandidate, word]);
        // set state to *selected*
        setIsSelected(true);
      }
    }
  }

  return (
    <Toggle
      className={`${styles.growShrink} ${styles.tileReveal} select-none min-h-[85px] px-2 py-2 w-full`}
      style={{ animationDelay: `${wordIndex * 45}ms` }}
      variant="outline"
      pressed={isSelected}
      onClick={flipSelection}
    >
      {isSelected && (
        <span
          className="absolute top-1.5 right-1.5 h-5 w-5 rounded-full bg-primary text-primary-foreground grid place-items-center"
          aria-hidden="true"
        >
          <Check className="h-3.5 w-3.5" strokeWidth={2.5} />
        </span>
      )}
      <p
        className={`${styles.wordLabel} font-plymouth font-bold uppercase text-[0.72em] sm:text-[0.82em] md:text-[0.9em] lg:text-[1em] text-center w-full`}
      >
        {word}
      </p>
    </Toggle>
  );
}

export default WordButton;
